import { cn } from '@/lib/cn';

interface AvatarSkeletonProps {
  count?: number;
  className?: string;
}

export function AvatarSkeleton({ count = 3, className }: AvatarSkeletonProps) {
  return (
    <div className={cn('flex flex-col gap-4', className)}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="aspect-square w-full animate-pulse overflow-hidden rounded-2xl bg-bg-secondary"
        />
      ))}
    </div>
  );
}
